
webpack.register(
    'modules/leaderboard/leaderboard',
    function() {
        return import('modules/leaderboard/leaderboard');
    },
    true
);